/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'
import SVG from 'react-inlinesvg'
import { toAbsoluteUrl, checkIsActive } from '../../../../_helpers'
import HouseIcon from '@material-ui/icons/House'
import ReceiptIcon from '@material-ui/icons/Receipt'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import AssessmentIcon from '@material-ui/icons/Assessment'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import DirectionsBoatIcon from '@material-ui/icons/DirectionsBoat'
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered'
import GavelIcon from '@material-ui/icons/Gavel'
import GpsFixedIcon from '@material-ui/icons/GpsFixed'
import ChatIcon from '@material-ui/icons/Chat'
import MenuBookIcon from '@material-ui/icons/MenuBook'
import EmojiFlagsIcon from '@material-ui/icons/EmojiFlags'
import { shallowEqual, useSelector } from 'react-redux'

export function AsideMenuList({ layoutProps }) {
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	)
	const isJudge = user?.role === 'judge' ? true : false
	const isClubManager = user?.role === 'club_manager' ? true : false

	const location = useLocation()
	const getMenuItemActive = (url, hasSubmenu = false, expectedView = null) => {
		const active = checkIsActive(location, url)
		if (!active)
			return ''

		// si esperamos un ?view=... comprobamos que coincida
		if (expectedView) {
			const params = new URLSearchParams(location.search)
			const currentView = params.get('view') || 'staff' // por defecto staff
			if (currentView !== expectedView)
				return ''
		}

		return ` ${!hasSubmenu && 'menu-item-active'} menu-item-open menu-item-not-hightlighted`
	}

	return (
		<>
			{/* begin::Menu Nav */}
			<ul className={`menu-nav ${layoutProps.ulClasses}`}>
				{/*begin::1 Level*/}
				<li
					className={`menu-item ${getMenuItemActive(
						'/dashboard',
						false
					)}`}
					aria-haspopup="true"
				>
					<NavLink className="menu-link" to="/dashboard">
						<span className="svg-icon menu-icon">
							<SVG
								src={toAbsoluteUrl(
									'/media/svg/icons/Design/Layers.svg'
								)}
							/>
						</span>
						<span className="menu-text">Dashboard</span>
					</NavLink>
				</li>
				<li className="menu-section">
					<h4 className="menu-text">{'Regatta'}</h4>
					<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
				</li>
				<li
					className={`menu-item ${getMenuItemActive(
						'/regattas',
						false
					)} ${getMenuItemActive('/edit-regatta', false)}`}
					aria-haspopup="true"
				>
					<NavLink className="menu-link" to="/regattas">
						<span className="menu-icon">
							<EmojiFlagsIcon />
						</span>
						<span className="menu-text">Regattas</span>
					</NavLink>
				</li>
				{isJudge || isClubManager ? (
					<>
					</>
				) : (
					<>
						<li className="menu-section">
							<h4 className="menu-text">ENTITIES</h4>
							<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/clubs',
								false
							)} ${getMenuItemActive('/edit-club', false)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/clubs">
								<span className="menu-icon">
									<HouseIcon />
								</span>
								<span className="menu-text">Clubs</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/sailors',
								false
							)} ${getMenuItemActive(
								'/edit-sailor',
								false
							)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/sailors">
								<span className="menu-icon">
									<AccountCircleIcon />
								</span>
								<span className="menu-text">Sailors</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/boats',
								false
							)} ${getMenuItemActive('/edit-boat', false)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/boats">
								<span className="menu-icon">
									<DirectionsBoatIcon />
								</span>
								<span className="menu-text">Boats</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/contracts',
								false
							)} ${getMenuItemActive('/alta-club', false)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/contracts">
								<span className="menu-icon">
									<ReceiptIcon />
								</span>
								<span className="menu-text">Contratos</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/gpsdevices',
								false
							)} ${getMenuItemActive('/edit-gpsdevice', false)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/gpsdevices">
								<span className="menu-icon">
									<GpsFixedIcon />
								</span>
								<span className="menu-text">GPS devices</span>
							</NavLink>
						</li>

						<li className="menu-section">
							<h4 className="menu-text">COMMUNICATION</h4>
							<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/articles',
								false
							)} ${getMenuItemActive('/edit-article', false)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/articles">
								<span className="menu-icon">
									<ChatIcon />
								</span>
								<span className="menu-text">
									Articles
								</span>
							</NavLink>
						</li>
						{/* Los textos legales de sailradar.com. Solo se editan: son
						    cuatro documentos fijos por tres idiomas. */}
						<li
							className={`menu-item ${getMenuItemActive(
								'/legal',
								false
							)} ${getMenuItemActive('/edit-legal', false)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/legal">
								<span className="menu-icon">
									<MenuBookIcon />
								</span>
								<span className="menu-text">
									Textos legales
								</span>
							</NavLink>
						</li>

						<li className="menu-section">
							<h4 className="menu-text">MANAGE</h4>
							<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/boatypes',
								false
							)} ${getMenuItemActive('/edit-boattype', false)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/boattypes">
								<span className="menu-icon">
									<FormatListNumberedIcon />
								</span>
								<span className="menu-text">
									Boat Types
								</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/admins',
								false,
								'staff'
							)} ${getMenuItemActive('/edit-admin', false, 'staff')}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/admins?view=staff">
								<span className="menu-icon">
									<AssignmentIndIcon />
								</span>
								<span className="menu-text">
									Administrators
								</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/admins',
								false,
								'judges'
							)} ${getMenuItemActive('/edit-admin', false, 'judges')}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/admins?view=judges">
								<span className="menu-icon">
									<GavelIcon />
								</span>
								<span className="menu-text">
									Judges
								</span>
							</NavLink>
						</li>
					</>
				)}

				{/*end::1 Level*/}
			</ul>

			{/* end::Menu Nav */}
		</>
	)
}
